// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3zD8d","author":"Table_author__je32H","authorImage":"Table_authorImage__1zUBj","unreadRow":"Table_unreadRow__3Phdt"};